import React, { useState, useEffect } from 'react';
import { referralAPI } from '../services/api';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';
import { formatDisplayDate } from '../utils/dateFormat';
import PageHeader from '../components/PageHeader';
import './IncompleteToCornerstone.css';

function IncompleteToCornerstone() {
  const { tenantPath } = useTenantFromUrl();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    referralAPI.getIncompleteCornerstoneList()
      .then((res) => setRows(res.data?.data ?? []))
      .catch(() => setError('Failed to load incomplete referrals'))
      .finally(() => setLoading(false));
  }, []);

  const handleOpen = (referralId) => {
    const url = `${window.location.origin}${tenantPath(`/cornerstone/${referralId}`)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="ic-cornerstone-page">
      <PageHeader title="Incomplete → Cornerstone" />
      {loading && <p className="ic-cornerstone-status">Loading…</p>}
      {error && <p className="ic-cornerstone-status ic-cornerstone-error">{error}</p>}
      {!loading && !error && rows.length === 0 && (
        <p className="ic-cornerstone-status">No incomplete referrals.</p>
      )}
      {!loading && !error && rows.length > 0 && (
        <table className="ic-cornerstone-table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Open Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>{row.last_name}, {row.first_name}</td>
                <td>{row.open_date ? formatDisplayDate(row.open_date) : '—'}</td>
                <td>
                  <button className="ic-cornerstone-open-btn" onClick={() => handleOpen(row.id)}>
                    Open
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default IncompleteToCornerstone;
